import { Typography } from '@mui/material';
import { ResponsibleTypeEnum } from '@schooly/api';
import { LIST_ROW_COLUMNS, TABLE } from '@schooly/constants';
import { GridCell, GridRow } from '@schooly/style';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { AttendanceFrequencyRowData } from './attendance-frequencies-helpers';
import { AttendanceFrequencyTimetableCell } from './AttendanceFrequencyTimetableCell';

const RESPONSIBLE_MESSAGE_ID: Record<ResponsibleTypeEnum, string> = {
  [ResponsibleTypeEnum.Tutor]: 'attendance-Frequencies-Responsible-Tutor',
  [ResponsibleTypeEnum.SubjectTeacher]: 'attendance-Frequencies-Responsible-SubjectTeacher',
};

interface Props {
  row: AttendanceFrequencyRowData;
}

export const AttendanceFrequencyRow: FC<Props> = ({ row }) => (
  <GridRow data-test-id={TABLE.ROW}>
    <GridCell data-test-id={LIST_ROW_COLUMNS.age_groups}>
      <Typography variant="h3">{row.displayLabels.join(', ')}</Typography>
    </GridCell>
    <GridCell data-test-id={LIST_ROW_COLUMNS.am_responsible}>
      <Typography>
        <FormattedMessage id={RESPONSIBLE_MESSAGE_ID[row.amResponsible]} />
      </Typography>
    </GridCell>
    <GridCell data-test-id={LIST_ROW_COLUMNS.pm_responsible}>
      <Typography color={!row.pmResponsible ? 'text.secondary' : undefined}>
        {row.pmResponsible ? (
          <FormattedMessage id={RESPONSIBLE_MESSAGE_ID[row.pmResponsible]} />
        ) : (
          '—'
        )}
      </Typography>
    </GridCell>
    <GridCell data-test-id={LIST_ROW_COLUMNS.per_period}>
      <Typography color={!row.perPeriodEnabled ? 'text.secondary' : undefined}>
        {row.perPeriodEnabled ? (
          <FormattedMessage id="attendance-Frequencies-PerPeriod-Enabled" />
        ) : (
          '—'
        )}
      </Typography>
    </GridCell>
    <GridCell data-test-id={LIST_ROW_COLUMNS.timetable}>
      <AttendanceFrequencyTimetableCell cell={row.timetable} />
    </GridCell>
  </GridRow>
);
